<script setup lang="ts">
import {
  Participant,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'
import PitchIncidentButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchIncidentButton/PitchIncidentButton.vue'
import PitchBlockedIncidentOverlay from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchIncidents/PitchParticipantWithIncidents/PitchBlockedIncidentOverlay.vue'

import ServePitchIncidentButton from './ServePitchIncidentButton.vue'

interface Props {
  participant: Participant
  reversed?: boolean
}

defineProps<Props>()
</script>

<template>
  <div class="relative w-full flex-1">
    <PitchBlockedIncidentOverlay />
    <div
      class="gap-y-fluid grid grid-cols-[1fr_auto] gap-x-2"
      :dir="reversed ? 'rtl' : undefined"
    >
      <PitchIncidentButton
        class="w-full"
        :participant
        :incidentId="VolleyballIncidentId.NeutralAttack"
      />

      <ServePitchIncidentButton :participant />

      <PitchIncidentButton
        class="w-full"
        :participant
        :incidentId="VolleyballIncidentId.Dig"
      />
    </div>
  </div>
</template>
